// mds-dojo — dijit/Destroyable — FAITHFUL port of references/dijit/Destroyable.js.
// Produced via `codemod/transformLegacyJs` (define([...],fn) → ESM + classic
// declare), then finished: imports the faithful declare runtime and is tsc-clean.
// Mixin to track handles and release them when the instance is destroyed.
import array from '../dojo/_base/array';
import aspect from '../dojo/aspect';
import declare from '../dojo/_base/declare-runtime';

export default declare('dijit.Destroyable', null, {
  destroy(this: any, _preserveDom?: boolean): void {
    // Destroy this class, releasing any resources registered via own().
    this._destroyed = true;
  },

  own(this: any): IArguments {
    // Track specified handles and remove/destroy them when this instance is
    // destroyed, unless they were already removed/destroyed manually.
    const cleanupMethods = [
      'destroyRecursive',
      'destroy',
      'remove',
    ];

    array.forEach(arguments as any, function (this: any, handle: any) {
      // When this.destroy() is called, destroy handle. Using aspect.before(), the
      // handle is destroyed before a subclass's destroy() starts running, before
      // it calls this.inherited() (or even if it doesn't call it at all).
      let destroyMethodName: string;
      const odh = aspect.before(this, 'destroy', function (preserveDom?: boolean) {
        handle[destroyMethodName](preserveDom);
      });

      // Callback for when handle is manually destroyed.
      const hdhs: any[] = [];
      function onManualDestroy(): void {
        odh.remove();
        array.forEach(hdhs, function (hdh: any) {
          hdh.remove();
        });
      }

      // Setup listeners for manual destroy of handle. Also computes
      // destroyMethodName, used in the listener above.
      if (handle.then) {
        // Special path for Promises. Detect when resolved/rejected/canceled
        // (cancelling a Promise causes it to be rejected).
        destroyMethodName = 'cancel';
        handle.then(onManualDestroy, onManualDestroy);
      } else {
        // Other handles: use AOP to detect manual destroy.
        array.forEach(cleanupMethods, function (cleanupMethod: string) {
          if (typeof handle[cleanupMethod] === 'function') {
            if (!destroyMethodName) {
              // First matching method name (prefer destroyRecursive to destroy).
              destroyMethodName = cleanupMethod;
            }
            hdhs.push(aspect.after(handle, cleanupMethod, onManualDestroy, true));
          }
        });
      }
    }, this);

    return arguments; // handle
  },
});
